import cicd from './cicd.json';
import devops from './devops.json';
import testing from './testing.json';

export interface MCPServer {
  id: string;
  name: string;
  hint: string;
  description: string;
  icon: string;
  iconBg: string;
  category: string;
  toolCount: number;
  topTools: string[];
  configs: Record<string, string>;
}

/**
 * To add a new category, create a JSON file in this folder (e.g. `ai.json`)
 * following the MCPServer[] schema, then import and spread it below.
 */
const allServers: MCPServer[] = [
  ...cicd,
  ...devops,
  ...testing,
];

export default allServers;
